import React, { useState, useCallback, useEffect, useRef } from 'react';
import useApi from '../../api/useApi';

function index({
  selectedDevice,
  handleClose,
  notification,
  refreshList,
  editZone,
  zoneId,
  warehouseId,
  selectedWarehouse,
}) {
  const orgId = JSON.parse(sessionStorage.user).organization.id;
  const { userId } = JSON.parse(sessionStorage.user).user;
  const formModel = {
    name: selectedDevice,
    warehouseId,
    direction: {
      radius: '',
      center: '',
      dimension: '',
      start: '',
    },
    shape: '',
    state: '',
    attributes: null,
    isActive: true,
    createdBy: userId,
  };

  const [formData, setFormData] = useState(formModel);
  const [{ isLoading, isError, data }, postData] = useApi();
  const [zoneData, getZoneData] = useApi();
  const [attributes, setAttributes] = useState();
  const key = useRef(null);
  const value = useRef(null);
  // const center = useRef(null);
  // const radius = useRef(null);
  // const start = useRef(null);
  // const dimension = useRef(null);
  useEffect(() => {
    if (editZone) {
      getZoneData(`/zone/${zoneId}`, 'GET');
      // getZoneData(`/zone/ZW05dVpRPT0zYmFmOWRkMC1iNTBkLTExZWMtODcyMi0xZjc3YTQyMTJkNDY=`, 'GET');
    }
  }, []);

  useEffect(() => {
    if (!zoneData.isLoading && !zoneData.isError && zoneData.data) {
      setFormData({
        name: zoneData?.data?.zone?.name,
        direction: {
          center: zoneData?.data?.zone?.direction?.center,
          radius: zoneData?.data?.zone?.direction?.radius,
          start: zoneData?.data?.zone?.direction?.start,
          dimension: zoneData?.data?.zone?.direction?.dimension,
        },
        shape: zoneData?.data?.zone?.shape,
        warehouseId,
        isActive: true,
        attributes: null,
        createdBy: zoneData?.data?.zone?.createdBy,
      });
    }
  }, [zoneData]);

  const handleInputChange = useCallback((e) => {
    if (e.target.name === 'center') {
      formData.direction.center = e.target.value;
    }
    if (e.target.name === 'radius') {
      formData.direction.radius = e.target.value;
    }
    if (e.target.name === 'dimension') {
      formData.direction.dimension = e.target.value;
    }

    if (e.target.name === 'start') {
      formData.direction.start = e.target.value;
    }

    setFormData({ ...formData, [e.target.name]: e.target.value });
  });
  const handleSubmit = (e) => {
    e.preventDefault();
    let body = {};
    if (formData.shape === 'CIRCLE') {
      const x = formData.direction.center;
      const myArray = Array.isArray(x) ? x : x.split(',');
      const centerArray = [];
      centerArray[0] = parseInt(myArray[0], 10);
      centerArray[1] = parseInt(myArray[1], 10);
      body = {
        ...formData,
        direction: {
          radius: parseInt(formData.direction.radius, 10),
          center: centerArray,
        },
        attributes,
      };
    } else if (formData.shape === 'RECTANGLE') {
      const x = formData.direction.dimension;
      const dimensionArray = Array.isArray(x) ? x : x.split(',');
      const centerArray = [];
      centerArray[0] = parseInt(dimensionArray[0], 10);
      centerArray[1] = parseInt(dimensionArray[1], 10);

      const y = formData.direction.start;
      const startArray = Array.isArray(y) ? y : y.split(',');
      const _startArray = [];
      _startArray[0] = parseInt(startArray[0], 10);
      _startArray[1] = parseInt(startArray[1], 10);
      body = {
        ...formData,
        direction: {
          start: _startArray,
          dimension: centerArray,
        },
        attributes,
      };
    } else {
      body = {
        ...formData,
        attributes,
      };
    }
    if (editZone) {
      postData(`/zone/${zoneId}`, 'PATCH', body);
    } else {
      postData(`/zone`, 'POST', body);
    }
  };

  const handleAddAttributes = () => {
    const x = { ...attributes };
    const k = key.current.value;
    const v = value.current.value;

    x[k] = v;
    setAttributes(x);
  };

  const deleteAttribute = (item) => {
    const attr = { ...attributes };
    delete attr[item[0]];

    setAttributes(attr);
  };
  useEffect(() => {
    key.current.value = '';
    value.current.value = '';
  }, [attributes]);

  useEffect(() => {}, [attributes]);

  useEffect(() => {
    if (!isLoading && !isError && data) {
      setFormData({ ...formModel });
      notification('success', `Zone Created successfully`);
      handleClose();
      refreshList();
    }
    if (isError) {
      notification('error', data);
      // refreshList();
    }
  }, [isLoading, isError, data]);

  return (
    <div
      className="flex justify-center items-center h-full w-full fixed z-20 left-0 right-0 bottom-0 top-0"
      style={{ background: 'linear-gradient(rgba(0, 0, 0, 0.5),   rgba(0, 0, 0, 0.5))' }}
    >
      <div className="bg-white w-2/4  pt-1 relative rounded-2xl mobile_toggle">
        <img
          src="assets/img/Close.svg"
          className="absolute top-6 right-6 h-3 cursor-pointer"
          alt=""
          onClick={handleClose}
        />
        <p className="font-bold text-sm text-textBlue1 border-b p-4 pl-6">{editZone ? 'Edit Zone' : 'Create Zone'}</p>
        {/* <p className="font-bold text-lg text-textBlue1">CREATE GATEWAY</p> */}
        <form className="mt-2 mb-2 mx-10 flex flex-wrap " onSubmit={handleSubmit} autoComplete="off">
          <div className="mt-5 w-2.25/5 relative ">
            <label htmlFor="Start" className="block text-parameter w-1/3 text-sm mr-2 font-bold">
              Zone Name
            </label>
            <input
              type="text"
              placeHolder="Zone Name"
              value={formData.name}
              autoComplete="off"
              name="name"
              className="inputLabelText px-4 py-2 focus:outline-none back-dim mt-2"
              onChange={handleInputChange}
            />
          </div>
          <div className="w-1/10" />
          {selectedWarehouse.floorPlan && (
            <div className="mt-5 w-2.25/5 relative ">
              <label htmlFor="Start" className="block text-parameter w-1/3 text-sm mr-2 font-bold">
                Shape
              </label>
              <div className="inputLabelText px-4 py-2 focus:outline-none mt-2">
                <select
                  name="shape"
                  value={formData.shape}
                  className="border-none w-full focus:outline-none text-sm font-normal text-parameter border "
                  onChange={handleInputChange}
                  style={{ color: '#b3b3b3' }}
                >
                  <option className="fy-4">Shape</option>
                  <option key="CIRCLE" value="CIRCLE" className="fy-4">
                    CIRCLE
                  </option>
                  <option key="RECTANGLE" value="RECTANGLE" className="fy-4">
                    RECTANGLE
                  </option>
                </select>
              </div>
            </div>
          )}
          {formData.shape === 'CIRCLE' && (
            <>
              <div className="mt-5 w-2.25/5 relative ">
                <label htmlFor="Start" className="block text-parameter w-1/3 text-sm mr-2 font-bold">
                  Center Point
                </label>
                <input
                  type="text"
                  name="center"
                  value={formData.direction.center}
                  onChange={handleInputChange}
                  placeHolder="Eg:- 60,70"
                  autoComplete="off"
                  className="inputLabelText px-4 py-2 focus:outline-none back-dim mt-2"
                  required
                />
              </div>
              <div className="w-1/10" />
              <div className="mt-5 w-2.25/5 relative">
                <label htmlFor="Start" className="block text-parameter w-1/3 text-sm mr-2 font-bold">
                  Radius
                </label>
                <input
                  type="text"
                  placeHolder="Eg:- 50"
                  // ref={radius}
                  name="radius"
                  onChange={handleInputChange}
                  value={formData.direction.radius}
                  autoComplete="off"
                  className="inputLabelText px-4 py-2 focus:outline-none back-dim mt-2"
                  required
                />
              </div>
            </>
          )}

          {formData.shape === 'RECTANGLE' && (
            <>
              <div className="mt-5 w-2.25/5 relative ">
                <label htmlFor="Start" className="block text-parameter w-full text-sm mr-2 font-bold">
                  Left-Bottom Point
                </label>
                <input
                  type="text"
                  name="start"
                  placeHolder="Eg:- 60,70"
                  onChange={handleInputChange}
                  value={formData.direction.start}
                  autoComplete="off"
                  className="inputLabelText px-4 py-2 focus:outline-none back-dim mt-2"
                  required
                />
              </div>
              <div className="w-1/10" />
              <div className="mt-5 w-2.25/5 relative">
                <label htmlFor="Start" className="block text-parameter w-1/3 text-sm mr-2 font-bold">
                  Dimension
                </label>
                <input
                  type="text"
                  placeHolder="Eg:- 4,5"
                  name="dimension"
                  onChange={handleInputChange}
                  value={formData.direction.dimension}
                  autoComplete="off"
                  className="inputLabelText px-4 py-2 focus:outline-none back-dim mt-2"
                  required
                />
              </div>
            </>
          )}

          <p className="mt-5 w-full text-xs font-bold">ATTRIBUTES</p>

          <div className="relative flex w-full">
            <div className="mt-5 w-2.25/5">
              {/* <label htmlFor="website" className="block text-parameter w-1/3 text-sm mr-2">
                KEY
              </label> */}
              <input type="text" ref={key} placeHolder="Key" className="inputLabelText px-4 py-2 focus:outline-none" />
            </div>

            <div className="w-1/10" />
            <div className="mt-5 w-2.25/5">
              {/* <label htmlFor="city" className="block text-parameter w-1/3 text-sm mr-2">
                VALUE
              </label> */}
              <input
                type="text"
                ref={value}
                placeHolder="Value"
                className="inputLabelText px-4 py-2 focus:outline-none"
              />
            </div>

            <img
              src="assets/img/Add.svg"
              className="absolute -right-8 h-6 top-7 cursor-pointer"
              alt=""
              onClick={handleAddAttributes}
            />
          </div>

          <div className="w-full flex mt-4">
            {attributes &&
              Object.entries(attributes).map((item) => (
                <p
                  className="relative text-black py-1 px-4 rounded-full border mr-2 cursor-pointer"
                  onClick={() => deleteAttribute(item)}
                >
                  {item.join(' - ')}
                  <img src="assets/img/Close.svg" className="h-2 absolute top-0 -right-1 cursor-pointer" alt="" />
                </p>
              ))}
          </div>

          {/* <div className="inputLabelText px-4 py-2 mt-6 h-32 w-full"></div> */}
          <div className="mt-5 w-2.25/5" />
          <div className="w-1/10" />
          <div className="w-2.25/5 mt-5 mb-2 relative">
            {isLoading ? (
              <img src="assets/img/loader.svg" className="absolute w-16 right-36 mx-auto bottom-0" alt="" />
            ) : (
              <div className="flex text-xs">
                <button
                  type="submit"
                  onClick={() => handleClose()}
                  className="rounded-3xl w-1/2  border focus:outline-none  h-10 mr-3 cursor-pointer "
                  // style={{ border: '1px solid #16406D' }}
                >
                  Cancel
                </button>
                <button
                  type="submit"
                  className="rounded-3xl w-1/2 focus:outline-none h-10 text-white bg-primary cursor-pointer "
                  style={{ border: '1px solid #16406D' }}
                >
                  Save
                </button>
              </div>
            )}
          </div>
        </form>
      </div>
    </div>
  );
}

export default index;
